import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import request from "../util/request";
import {
    VERIFY_OTP,
} from 'constants/ActionTypes';
import {
    verify_otp_success,
    verify_otp_failed
} from 'actions/otp';

import { setCookie } from "util/helpers";

const user_otp_request = async (payload) => (
    await request({
        path: '/verify-otp',
        method: 'POST',
        body: JSON.stringify(payload),
    })
)

function* send_otp_saga({ payload }) {
    try {
        const response = yield call(user_otp_request, payload);
        const { data } = response;
        if (response.status === 202 || response.code === "otp_verified") {
            localStorage.setItem('user_id', data.user_id);
            // document.cookie = `token=${response.data.token};path=/`;
            setCookie('token', response.data.token);
            yield put(verify_otp_success(response.data));
            window.location = "/";
        } else {
            yield put(verify_otp_failed(response));
        }
    } catch (error) {
        console.error(error)
    }
}

export function* verify_otp() {
    yield takeLatest(VERIFY_OTP, send_otp_saga);
}
export default function* rootSaga() {
    yield all([
        fork(verify_otp),
    ]);
}